import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid2';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Iconify } from '@mgm/common/components';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getCommissionPlans } from '../../../store/commissions/selectors';
import { getMembers } from '../../../store/team/selectors';

const CommissionPlansHeader = () => {
  const commissionsPlan = useAppSelector(getCommissionPlans);
  const members = useAppSelector(getMembers);
  const { t } = useTranslation('commissions');

  const totals = useMemo(() => {
    const fixedPlans = commissionsPlan?.filter((plan) => plan.type === 'Fixed').length || 0;
    const stepsPlans = commissionsPlan?.filter((plan) => plan.type === 'Steps').length || 0;

    return {
      fixedPlans,
      stepsPlans,
    };
  }, [commissionsPlan]);

  const membersWithPlan = members.filter((member) => member.commissionPlan?.name).length;

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12, sm: 6, md: 6, lg: 4,
        }}
      >
        <Card
          id="fixed-plans"
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CardContent sx={{ flexGrow: 1, p: 0 }}>
            <Box px={3}>
              <Typography variant="h4" component="div">
                {totals.fixedPlans}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('fixedPlans')}
              </Typography>
            </Box>
          </CardContent>
          <Box
            sx={{
              background: '#f3e8ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 2.5,
            }}
          >
            <Iconify
              icon="mdi:lock-rate-outline"
              width={48}
              sx={{
                color: '#A855F7',
              }}
            />
          </Box>
        </Card>
      </Grid>
      <Grid
        size={{
          xs: 12, sm: 6, md: 6, lg: 4,
        }}
      >
        <Card
          id="steps-plans"
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CardContent sx={{ flexGrow: 1, p: 0 }}>
            <Box px={3}>
              <Typography variant="h4" component="div">
                {totals.stepsPlans}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('stepsPlans')}
              </Typography>
            </Box>
          </CardContent>
          <Box
            sx={{
              background: '#D3FCD2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 2.6,
            }}
          >
            <Iconify
              icon="lucide-lab:stairs-arrow-up-right"
              width={48}
              sx={{
                color: '#005249',
              }}
            />
          </Box>
        </Card>
      </Grid>
      <Grid
        size={{
          xs: 12, sm: 6, md: 6, lg: 4,
        }}
      >
        <Card
          id="team-members-with-plans"
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CardContent sx={{ flexGrow: 1, p: 0 }}>
            <Box px={3}>
              <Typography variant="h4" component="div">
                {`${membersWithPlan}/${members.length}`}
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('teamMembersWithPlans')}
              </Typography>
            </Box>
          </CardContent>
          <Box
            sx={{
              background: '#D0F2FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 2.1,
            }}
          >
            <Iconify
              icon="fluent:people-team-16-regular"
              width={55}
              sx={{
                color: '#04297A',
              }}
            />

          </Box>
        </Card>
      </Grid>
    </Grid>
  );
};

export {
  CommissionPlansHeader,
};
